import React from 'react';
import { View, Text, Flex } from '@adobe/react-spectrum';
import styles from './FeaturesSection.module.scss';

interface FeaturesSectionProps {
  features?: string[];
}

export const FeaturesSection: React.FC<FeaturesSectionProps> = ({
  features = []
}) => {
  return (
    <View UNSAFE_className={styles.featuresSection}>
      <Text UNSAFE_className={styles.sectionTitle}>Features</Text>
      <Flex direction="column" gap="size-200">
        {features.length > 0 ? (
          features.map((feature, index) => (
            <View key={index} UNSAFE_className={styles.featureItem}>
              <Text>{feature}</Text>
            </View>
          ))
        ) : (
          <Text>No features available</Text>
        )}
      </Flex>
    </View>
  );
};

export default FeaturesSection;
